<div class="notification-container">
  <div class="d-flex">
      <mat-icon (click)="closeAll()" class="close-btn" alt="cerrar">close</mat-icon>
  </div>
  <div #containerCards class="container-cards">
      <ng-container #container></ng-container>
  </div>
</div>
